<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col>
          <el-card class="box-card">
            <div class="Header">
              <span>{{ UploadHeader }}: </span>
            </div>
            <el-upload
              action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
              class="upload-demo"
              :file-list="fileList"
              :on-success="handleSuccess"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              list-type="picture-card"
              ref="upload"
              :auto-upload="true"
            >
              <el-tooltip
                content="Clic para seleccionar archivos"
                placement="top"
              >
                <el-button
                  icon="el-icon-paperclip"
                  size="medium"
                  type="primary"
                ></el-button>
              </el-tooltip>

              <!-- <el-tooltip content="Clic para guardar archivos" placement="top">
                <el-button
                  icon="el-icon-upload"
                  size="medium"
                  type="success"
                  @click="submitUpload"
                ></el-button>
              </el-tooltip> -->

              <div
                slot="file"
                slot-scope="{ file }"
                v-if="
                  !file.name.includes(
                    '.jpg',
                    '.jpeg',
                    '.gif',
                    '.png',
                    '.tif',
                    '.tiff',
                    '.bmp'
                  )
                "
              >
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.imgUrl"
                  alt=""
                />

                <span class="el-upload-list__item-actions">
                  <el-tooltip content="Clic para ver archivo" placement="top">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                  </el-tooltip>
                  <!-- <span
                      class="el-upload-list__item-delete"
                      @click="handleDownload(file)"
                    >
                      <i class="el-icon-download"></i>
                    </span> -->
                  <el-tooltip
                    content="Clic para eliminar archivo"
                    placement="top"
                  >
                    <span
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </el-tooltip>

                  <div slot="tip" id="divTip" class="el-upload-list__item">
                    <b>{{ file.name }}</b>
                  </div>
                </span>
              </div>

              <div slot="tip" class="el-upload__tip">
                Puede seleccionar archivos con el boton azul,<br />
                Puede verlos colocando el mouse sobre los archivos y haciendo
                click en la lupa,<br />
                Puede eliminarlos colocando el mouse sobre los archivos y
                haciendo click en el safacon
              </div>
            </el-upload>
            <!-- <el-tooltip content="Clic para guardar archivos" placement="top">
                <el-button
                  icon="el-icon-upload"
                  size="medium"
                  type="success"
                  @click="submitUpload"
                ></el-button>
              </el-tooltip> -->
          </el-card>
        </el-col>
        <el-dialog
          v-if="WatchImage"
          :title="titleOrgChart"
          :close-on-click-modal="false"
          :fullscreen="true"
          :visible.sync="dialogVisible"
          width="100%"
          :center="true"
          @close="onClose"
        >
          <!--<img :src="imgUrl" alt="">-->
          <v-zoomer
            ref="zoomer"
            style="width: 100%; height: 800px; border: solid 1px silver"
          >
            <img
              width="100%"
              :src="imgUrl"
              style="object-fit: contain; width: 100%; height: 100%"
            />
          </v-zoomer>
          <div>
            <p>
              Puede ampliar o disminuir la imagen haciendo doble click o rodando
              la rueda del mouse
              <br />
              Puede mover la imagen una vez ampliada clickeando y manteniendo
              hacia el area que la auiera mover
            </p>
          </div>
          <!--
            <div class="img-magnifier-container">
              <img id="myimage" :src="imgUrl" width="100%" alt="" @mouseover="magnify">
            </div>
          -->
        </el-dialog>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
//import axios from "axios";
export default {
  name: "CustomersFilesUploader",
  setup() {},
  props: {
    UploadHeader: {
      type: String,
      default: "",
      required: true
    },
    DocumentType: {
      type: Number,
      default: 0,
      required: true
    },
    CompanyCode: {
      type: String,
      default: "",
      required: true
    },
    WatchImage: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      fileList: [],
      documentType: 0,
      companyCode: "",
      imgUrl: "",
      dialogVisible: false,
      titleOrgChart: ""
    };
  },
  mounted(companyCode, documentType) {
    this.fileList = [];
    documentType = this.DocumentType;
    companyCode = this.CompanyCode;
    this.GetDocuments(companyCode, documentType);
  },
  /*
  updated() {
    // console.log("imgUrl: ",this.imgUrl);
    //   this.$forceUpdate(); // no descomente este codigo
  },
  */
  computed: {
    /*
    imgUrl (file) {
      console.log("hola imgUrl")
      console.log("file: ", file)
      return file.url
    }
    */
  },
  methods: {
    /*
    submitUpload() {
      this.$refs.upload.submit();
    },
    */
    async GetDocuments(CompanyCode, DocumentType) {
      const Api = "/api/LegalDocuments/getOurCompanyDocuments";
      //const params = `/CustomerCode=${CustomerCode}&DocumentType=${DocumentType}`;

      const params = {
        params: {
          CompanyCode: CompanyCode,
          DocumentType: DocumentType,
          IsEaneable: true
        }
      };

      await this.$http
        .get(Api, params)
        .then((resp) => {
          let { data } = resp;
          data.forEach((doc) => {
            if (this.fileList.name != doc.DocumentName) {
              if (doc.DocumentName.includes(".doc", ".docx", ".docm")) {
                this.imgUrl =
                  "https://cdn.icon-icons.com/icons2/2397/PNG/512/microsoft_office_word_logo_icon_145724.png";
                //this.$forceUpdate();
              } else if (doc.DocumentName.includes(".pdf")) {
                this.imgUrl =
                  "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Adobe_Acrobat_DC_logo_2020.svg/768px-Adobe_Acrobat_DC_logo_2020.svg.png?20210212032411";
              } else if (doc.DocumentName.includes(".ppt", ".pptx", "pptm")) {
                this.imgUrl =
                  "https://cdn.icon-icons.com/icons2/2397/PNG/512/microsoft_power_point_office_logo_icon_145723.png";
              } else if (doc.DocumentName.includes(".xls", ".xlsx", ".xlsm")) {
                this.imgUrl =
                  "https://cdn.icon-icons.com/icons2/2397/PNG/512/microsoft_office_excel_logo_icon_145720.png";
              } else {
                this.imgUrl = doc.DocumentUrl;
                //this.$forceUpdate();
              }
              this.fileList.push({
                name: doc.DocumentName,
                url: doc.DocumentUrl,
                uid: doc.DocumentUid,
                imgUrl: this.imgUrl
              });
            }
          });
        })
        .catch((err) => {
          console.error(
            `${err.name}:  ${err.message} `,
            "\n Error Detail: ",
            err
          );
          /*
          this.$message({
            type: "error",
            message: `${err.name}:  ${err.message} `,
            center: true
          });
          */
        })
        .finally(() => {});
    },
    handleRemove(file /*, fileList*/) {
      this.$confirm(
        "Esto borrara el archivo permenentemente. Desea Continuar?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          /*
          this.$message({
            type: "success",
            message: "Delete completed"
          });
          */
          const Api = "/api/LegalDocuments/disableOurCompanyDocuments";

          const params = {
            CompanyCode: this.CompanyCode,
            DocumentType: this.DocumentType,
            DocumentName: file.name,
            DocumentUrl: file.url,
            DocumentUid: file.uid,
            IsEaneable: false
          };
          this.$http
            .put(Api, params)
            .then((resp) => {
              let { DocumentName } = resp.data;
              this.$message({
                showClose: true,
                message: `Se ha eliminado el archivo "${DocumentName}" satisfactoriamente`,
                type: "success",
                center: true,
                offset: 30
              });
              this.fileList = [];
              this.GetDocuments(this.CompanyCode, this.DocumentType);
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: `${err.name}:  ${err.message} `,
                center: true
              });
            })
            .finally(() => {});
        })
        .catch((companyCode, documentType) => {
          this.$message({
            type: "info",
            message: "Se ha cancelado el borrado del documento"
          });
          this.fileList = [];
          documentType = this.DocumentType;
          companyCode = this.CompanyCode;
          this.GetDocuments(companyCode, documentType);
        });
    },
    handlePreview(file) {
      // URL.createObjectURL(file.response[0].Url);
      /*
      console.log("file: ", file);
      console.log("WatchImage: ", this.WatchImage);
      */
      if (this.WatchImage === true) {
        this.imgUrl = Object.prototype.hasOwnProperty.call(file, "url")
          ? file.url
          : file.response[0].Url;
        this.titleOrgChart = file.name;
        this.dialogVisible = true;
      } else {
        let link = document.createElement("a");
        //console.log("link: ", link);
        link.href = Object.prototype.hasOwnProperty.call(file, "url")
          ? file.url
          : file.response[0].Url; //file.response[0].Url != null || file.response[0].Url != undefined? file.response[0].Url :
        link.download = "download";
        link.target = "_blank";
        link.click();
      }
    },
    handleSuccess(response, file /*, fileList*/) {
      //this.fileList.push({})

      const Api = "/api/LegalDocuments/saveOurCompanyDocuments";

      const params = {
        CompanyCode: this.CompanyCode,
        DocumentType: this.DocumentType,
        DocumentName: file.response[0].Name,
        DocumentUrl: file.response[0].Url,
        DocumentUid: file.uid,
        IsEaneable: true
      };
      this.$http
        .post(Api, params)
        .then((resp) => {
          let { DocumentName } = resp.data;
          this.$message({
            showClose: true,
            message: `Se ha guardado el archivo "${DocumentName}" satisfactoriamente`,
            type: "success",
            center: true,
            offset: 30
          });
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: `${err.name}:  ${err.message} `,
            center: true
          });
        })
        .finally(() => {
          this.fileList = [];
          this.GetDocuments(this.CompanyCode, this.DocumentType);
        });
    },
    onClose() {
      //console.log("cerrando...");
      this.$refs.zoomer.reset();
    }
    // ,
    // magnify(imgID, zoom) {
    //   console.log("nueva imagen magnificandose")
    //   imgID = "myimage"
    //   zoom = 3
    //   var img, glass, w, h, bw;
    //   img = document.getElementById(imgID);

    //   /* Create magnifier glass: */
    //   glass = document.createElement("DIV");
    //   glass.setAttribute("class", "img-magnifier-glass");

    //   /* Insert magnifier glass: */
    //   img.parentElement.insertBefore(glass, img);

    //   /* Set background properties for the magnifier glass: */
    //   glass.style.backgroundImage = "url('" + img.src + "')";
    //   glass.style.backgroundRepeat = "no-repeat";
    //   glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";
    //   bw = 3;
    //   w = glass.offsetWidth / 2;
    //   h = glass.offsetHeight / 2;

    //   /* Execute a function when someone moves the magnifier glass over the image: */
    //   glass.addEventListener("mousemove", moveMagnifier);
    //   img.addEventListener("mousemove", moveMagnifier);

    //   /*and also for touch screens:*/
    //   glass.addEventListener("touchmove", moveMagnifier);
    //   img.addEventListener("touchmove", moveMagnifier);
    //   function moveMagnifier(e) {
    //     var pos, x, y;
    //     /* Prevent any other actions that may occur when moving over the image */
    //     e.preventDefault();
    //     /* Get the cursor's x and y positions: */
    //     pos = getCursorPos(e);
    //     x = pos.x;
    //     y = pos.y;
    //     /* Prevent the magnifier glass from being positioned outside the image: */
    //     if (x > img.width - (w / zoom)) {x = img.width - (w / zoom);}
    //     if (x < w / zoom) {x = w / zoom;}
    //     if (y > img.height - (h / zoom)) {y = img.height - (h / zoom);}
    //     if (y < h / zoom) {y = h / zoom;}
    //     /* Set the position of the magnifier glass: */
    //     glass.style.left = (x - w) + "px";
    //     glass.style.top = (y - h) + "px";
    //     /* Display what the magnifier glass "sees": */
    //     glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
    //   }

    //   function getCursorPos(e) {
    //     var a, x = 0, y = 0;
    //     e = e || window.event;
    //     /* Get the x and y positions of the image: */
    //     a = img.getBoundingClientRect();
    //     /* Calculate the cursor's x and y coordinates, relative to the image: */
    //     x = e.pageX - a.left;
    //     y = e.pageY - a.top;
    //     /* Consider any page scrolling: */
    //     x = x - window.pageXOffset;
    //     y = y - window.pageYOffset;
    //     return {x : x, y : y};
    //   }
    // }
  },
  watch: {
    CompanyCode(companyCode, documentType) {
      this.fileList = [];
      documentType = this.DocumentType;
      companyCode = this.CompanyCode;
      this.GetDocuments(companyCode, documentType);
    }
    /*,
    imgUrl(imgUrl) {
      console.log("imgUrl: ", imgUrl);
      this.$forceUpdate();
    }*/
  }
};
</script>

<style scoped>
.Header {
  color: Black;
  padding-bottom: 15px;
}
#divTip {
  padding-bottom: 0px;
  margin-bottom: 0px;
  font-size: x-small;
}
/*
* {box-sizing: border-box;}

.img-magnifier-container {
  position: relative;
}

.img-magnifier-glass {
  position: absolute;
  border: 3px solid #000;
  border-radius: 50%;
  cursor: none;
  *Set the size of the magnifier glass:*
  width: 100px;
  height: 100px;
}
*/
</style>
